'use strict';

angular.module('TurneroApp').component('coListadoLlamador', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
        esLlamador: '<'
    },
    controller: [
        '$timeout',
        'llamadorService',
        'signalrDotNetCoreService',
        'utilsService',
        '$interval',
        'TurneroAppConstant',
        '$scope',
        function ($timeout, llamadorService, signalrServiceExterno, utilsService, $interval, TurneroAppConstant, $scope) {
            var ctrl = this;

            ctrl.sTurnos = true;
            ctrl.sTurnoActivo = false;
            ctrl.mostrandoTurnos = false;
            ctrl.turnoLlamado = {};
            ctrl.listaTurnos = [];
            ctrl.soundID = null;
            ctrl.llamador = {
                speaker: window.speechSynthesis
            }
            var voices = window.speechSynthesis.getVoices()
            var spanishVoices = voices.filter(v => v.lang === 'es-ES');
            
            ctrl.llamador.utterance = new window.SpeechSynthesisUtterance();
            ctrl.llamador.utterance.lang = 'es-ES';
            ctrl.llamador.utterance.voice = spanishVoices.length > 0 ? spanishVoices[0] : voices[0];
            ctrl.llamador.utterance.volume = 1.0;
            ctrl.llamador.utterance.rate = 1.0;
            ctrl.llamador.utterance.pitch = 1.0;


            ctrl.$onInit = function () {
            }

            ctrl.$onDestroy = function () {
                //cuando el componente se destruye se cancela el interval
                if (ctrl.intervalAccionesTemporizadas)
                    $interval.cancel(ctrl.intervalAccionesTemporizadas);
            };


            var mostrarTurno = function (turno) {
                if (turno.Id_Turno) {
                    ctrl.sTurnos = false;
                    ctrl.sTurnoActivo = true;
                    ctrl.mostrandoTurnos = true;

                    ctrl.turnoLlamado = turno;
                    var estaLista = ctrl.turnos.some(function (t) {
                        return t.Id_Turno == turno.Id_Turno;
                    });

                    if (!estaLista) {
                        ctrl.turnos.unshift(turno);
                    }
                    if (ctrl.soundID != null) createjs.Sound.play(ctrl.soundID);
                    $timeout(function () {
                        speak(ctrl.turnoLlamado);
                    }, 3000);


                    for (var i = 0; i < ctrl.listaTurnos.length; i++) {
                        if (turno.Id_Turno == ctrl.listaTurnos[i].Id_Turno) {
                            ctrl.listaTurnos.splice(i, 1);
                            break;
                        }
                    }

                    $timeout(function () {

                        ctrl.sTurnos = true;
                        ctrl.sTurnoActivo = false;

                        if (ctrl.listaTurnos.length === 0) {
                            ctrl.mostrandoTurnos = false;
                        }
                        else {
                            $timeout(function () {
                                //Por cuestiones de concurrencia/timing se tiene que controlar si el listado no está ya vacío.
                                var turnoRemoved = ctrl.listaTurnos.shift();
                                if (turnoRemoved) {
                                    mostrarTurno(turnoRemoved);
                                } else {
                                    ctrl.mostrandoTurnos = false;
                                }
                            }, 2000);
                        }
                    }, 9000);
                }
            };

            ///Esta funcion recibe el turno y prepara lo que va a decir el llamador
            function speak(turno) {

                if (turno.Pronunciar_Nombre == 1) {

                    var voices = [];

                    var text = 'Llamando a ' + turno.Identificador.toLowerCase() + '.';

                    if (turno.Box != null && turno.Box != '') {
                        text += ' Presentarse por ' + turno.Box;
                    }

                    if (turno.N_Grupo_Puestos !== null && turno.N_Grupo_Puestos !== '' && turno.N_Grupo_Puestos !== undefined) {
                        text += ' En área de ' + turno.N_Grupo_Puestos;
                    }

                    if (text !== '') {

                        window.speechSynthesis.cancel();
                        //setear lo que se va a decir
                        ctrl.llamador.utterance.text = text;
                        //Speak the phrase
                        ctrl.llamador.speaker.speak(ctrl.llamador.utterance);
                    }
                }
            }

            ctrl.$onChanges = function () {
                if (ctrl.esLlamador) {
                    ctrl.centroAtencionSeleccionado && ctrl.grillaReload();
                    ctrl.startListing()
                }
            };
            
            ctrl.onMostrarTurno = function (turno) {
                console.info("Se recibió notificación de MostrarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + (turno == null ? turno : turno.Id_Turno ) + ".");
                if (ctrl.mostrandoTurnos) {
                    ctrl.listaTurnos.push(turno);
                }
                else {
                    mostrarTurno(turno);
                }
            };

            ctrl.onEliminarTurno = function (id_turno) {
                console.info("Se recibió notificación de EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + id_turno + ".");
                if (ctrl.turnos) {
                    for (var i = 0; i < ctrl.turnos.length; i++) {
                        if (id_turno == ctrl.turnos[i].Id_Turno) {
                            ctrl.turnos.splice(i, 1);
                            //ctrl.listaTurnos.shift()
                            break;
                        }
                    }
                    for (var i = 0; i < ctrl.listaTurnos.length; i++) {
                        if (id_turno == ctrl.listaTurnos[i].Id_Turno) {
                            ctrl.listaTurnos.splice(i, 1);
                            break;
                        }
                    }
                }
            };

            ctrl.onUltimoTurnoAtendido = function (turno) {
                console.info("Se recibió notificación de UltimoTurnoAtendido en " + TurneroAppConstant.HubNames.LLAMADOR + " para el turno " + (turno == null ? turno : turno.Id_Turno) + ".");
                ctrl.ultimo_turno_atendido = turno;
            };

            ctrl.startListing = function () {
                if (ctrl.centroAtencionSeleccionado) {
                    signalrServiceExterno.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                        hub.invoke('AgregarGrupo', ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a AgregarGrupo en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                            //agregar un turno al llamador
                            hub.on("MostrarTurno", ctrl.onMostrarTurno);

                            //eliminar turno del llamador, por cambio de estado 
                            hub.on("EliminarTurno", ctrl.onEliminarTurno);

                            //mostrar ultimo turno atendido
                            hub.on("UltimoTurnoAtendido", ctrl.onUltimoTurnoAtendido);
                        }).catch(function (err) {
                            console.error("Falló invocación a AgregarGrupo en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                        });
                    }).catch(function () {
                        //si no se pudo conectar al hub en primera instancia activo las acciones temporizadas
                        ctrl.activarAccionesTemporizadas();
                    });
                }
            }

            ctrl.grillaReload = function () {

                llamadorService.listadoTurnosLlamador({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (result) {
                    if (result.Data.Sonido == 'Silencioso') {
                        ctrl.soundID = null;
                    } else if (result.Data.Sonido == 'null') {
                        ctrl.soundID = "Ding-dong-Out-2";
                    } else {
                        ctrl.soundID = result.Data.Sonido;
                    }

                    createjs.Sound.volume = 0.25;
                    if (ctrl.soundID != null) createjs.Sound.registerSound("assets/sounds/" + ctrl.soundID + '.mp3', ctrl.soundID);

                    ctrl.turnos = result.Data.Listado;

                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.desconectar = function () {
                //signalrServiceExterno.disconnect();
                signalrServiceExterno.stopHub(TurneroAppConstant.HubNames.LLAMADOR);
            };

            ctrl.accionesTemporizadas = function () {
                ctrl.grillaReload();
                console.info('Actualiza por desconexión del hub.')
            }

            ctrl.activarAccionesTemporizadas = function () {
                //este if está para que se cree un solo interval y pueda ser capturado para luego cerrarse
                if (!ctrl.intervalAccionesTemporizadas) {
                    ctrl.intervalAccionesTemporizadas = $interval(ctrl.accionesTemporizadas, TurneroAppConstant.HubDisconnectedIntervals.General);
                }
            }

            ctrl.desactivarAccionesTemporizadas = function () {
                if (ctrl.intervalAccionesTemporizadas) {
                    //cancelo el intervalo
                    $interval.cancel(ctrl.intervalAccionesTemporizadas);
                    ctrl.intervalAccionesTemporizadas = undefined;

                    //llamo por ultima vez a las acciones para que queden actualizadas
                    ctrl.accionesTemporizadas();
                }
            }

            //cuando se conecta al hub detengo las acciones temporizadas
            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                //lo agrega al Grupo del centro de atencion.
                if (hub.connection.baseUrl.indexOf(TurneroAppConstant.HubNames.LLAMADOR) !== -1
                    && ctrl.centroAtencionSeleccionado) {
                    hub.invoke('AgregarGrupo', ctrl.centroAtencionSeleccionado.id).then(function () {
                        console.info("Se invocó a AgregarGrupo en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                        ctrl.desactivarAccionesTemporizadas();
                    }).catch(function (err) {
                        console.error("Falló invocación a AgregarGrupo en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                    });
                }
            });

            //cuando se desconecta el hub realizo las acciones temporizadas
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.activarAccionesTemporizadas();
            });
        }
    ],
    template: require('./listadoLlamador.html')
});


// WEBPACK FOOTER //
// ./app/components/llamador/listadoLlamadorComponent.js